import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function InventoryIcon(props: IconProps) {
    return <Icon {...props} iconKey={"inventory"}/>
}
